import { SingleActionAlertProps, showSingleActionPopUp } from './singleAction'

import { evaluationModal, EvaluationModalProps } from './evaluationModal'
import { showTemplatePopup, TemplatePopupProps } from './templateModal'
import { assignModal, AssignModalProps } from './assignModal'
import { DoubleActionAlertProps, showDoubleActionPopUp } from './doubleAction'
import { confirmationUpdateModal, ConfirmationUpdateModalProps } from './confirmationUpdateModal'
import { showStartupPopUp, StartupProps } from './startupModal'
import { ConfirmationProps, showConfirmationPopUp } from './confirmationModal'
import { connectModal, ConnectModalProps } from './connectModal'
import { quickConnectModal, QuickConnectModalProps } from './quickConnectModal'
import { connectionDataModal, ConnectionDataModalProps } from './connectionDataModal'
import { StartupAlreadyExistsModal, StartupAlreadyExistsModalProps } from './startupAlreadyExistsModal'
import { editTitleModal, EditTitleModalProps } from './editTitleModal'

export const showModal = (
  type: string,
  info: SingleActionAlertProps | DoubleActionAlertProps | EvaluationModalProps | AssignModalProps | TemplatePopupProps | ConfirmationUpdateModalProps | ConnectModalProps | QuickConnectModalProps | ConnectionDataModalProps | ConfirmationProps | StartupProps | EditTitleModalProps
): void => {
  switch (type) {
    case 'single':
      showSingleActionPopUp(info as SingleActionAlertProps)
      break
    case 'double':
      showDoubleActionPopUp(info as DoubleActionAlertProps)
      break
    case 'startup':
      showStartupPopUp(info as StartupProps)
      break
    case 'confirmation':
      showConfirmationPopUp(info as ConfirmationProps)
      break
    case 'template':
      showTemplatePopup(info as TemplatePopupProps)
      break
    case 'evaluationModal':
      evaluationModal(info as EvaluationModalProps)
      break
    case 'assignModal':
      assignModal(info as AssignModalProps)
      break
    case 'confirmation-update':
      confirmationUpdateModal(info as ConfirmationUpdateModalProps)
      break
      case 'connect':
      connectModal(info as ConnectModalProps)
      break
    case 'quickConnect':
      quickConnectModal(info as QuickConnectModalProps)
      break
    case 'connectionData':
      connectionDataModal(info as ConnectionDataModalProps)
      break
    case 'startupAlreadyExists':
      StartupAlreadyExistsModal(info as StartupAlreadyExistsModalProps)
      break
    case 'editTitle':
      editTitleModal(info as EditTitleModalProps)
      break
    default:
      break
  }
}
